import React from "react";
import cs from "classnames";

import "./UserViewType.scss";

export const UserViewType = ({
  type = "Coordinator view",
}: {
  type?: string;
}) => {
  return <div className={cs("UserViewType")}>{type}</div>;
};
